const VALID_DEMOGRAPHICS_SOURCES = ['sensortower', 'appannie'];

/**
 * source 仅允许 sensortower / appannie，其他值重置为 sensortower
 */
export function validateDemographicsSource(source: string): string {
  return VALID_DEMOGRAPHICS_SOURCES.includes(source) ? source : 'sensortower';
}
